var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 586.63 564.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e5b38a;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-10 {\n        stroke: #ccc;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-10, .cls-11, .cls-12, .cls-13 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .cls-11 {\n        stroke: #b3b3b3;\n      }\n\n      .cls-11, .cls-12, .cls-13 {\n        stroke-linejoin: round;\n      }\n\n      .cls-14 {\n        fill: #dba57d;\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-12 {\n        stroke: #84693b;\n      }\n\n      .cls-13 {\n        stroke: #000;\n      }\n\n      .cls-16, .cls-17 {\n        fill: #84693b;\n      }\n\n      .cls-18 {\n        fill: #311d0d;\n      }\n\n      .cls-19 {\n        fill: #fff;\n      }\n\n      .cls-20 {\n        fill: #f9dec9;\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-43 {\n        fill: #b1abab;\n      }\n\n      .cls-44 {\n        opacity: .2;\n      }\n\n      .cls-45, .cls-17 {\n        opacity: .1;\n      }\n\n      .cls-46 {\n        fill: #f4d2b6;\n      }\n\n      .cls-47 {\n        fill: #d29770;\n      }\n\n      .cls-48 {\n        fill: #333;\n      }\n\n      .cls-49 {\n        fill: #edbf9b;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5395.11,
    y1: -119.18,
    x2: 5022.52,
    y2: 353.72,
    gradientTransform: "translate(5638.85) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 5015.28,
    y1: 111.22,
    x2: 5761.51,
    y2: 401.91,
    gradientTransform: "translate(5638.85) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f6f4f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ebe7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#dcd4c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#c8bca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#af9e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#937b53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84693b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 387.39,
    y1: 136.82,
    x2: 504.37,
    y2: 338.78,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 556.38,
    y1: 213.4,
    x2: 306.94,
    y2: 412.95,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 355.42,
    y1: 659.96,
    x2: 61.95,
    y2: 206.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84693b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#a99676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e6e1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 386.59,
    y1: 65.94,
    x2: 82.79,
    y2: 472.77,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 72.54,
    y1: 391.09,
    x2: 183.46,
    y2: 238.62,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 58,
    y1: 472.5,
    x2: 89.32,
    y2: 472.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 111.35,
    y1: 502.55,
    x2: 144.72,
    y2: 502.55,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -31.33,
    y1: 316.34,
    x2: 238.32,
    y2: 477.11,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 16.19,
    y1: 360.05,
    x2: 137.38,
    y2: 420.87,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 147.2,
    y1: 373.02,
    x2: 162.48,
    y2: 421.95,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 85.83,
    y1: 359.61,
    x2: 201.07,
    y2: 359.61,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 78.78,
    y1: 395.63,
    x2: 189.7,
    y2: 243.16,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 236.4,
    y1: 441.33,
    x2: 238.65,
    y2: 217.03,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 213.62,
    y1: 441.1,
    x2: 215.87,
    y2: 216.8,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 174.58,
    y1: 215.15,
    x2: 222.06,
    y2: 215.15,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 100.71,
    y1: 396.12,
    x2: 137.93,
    y2: 291.72,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 89.33,
    y1: 392.07,
    x2: 126.55,
    y2: 287.67,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 177.46,
    y1: 278.7,
    x2: 63.2,
    y2: 411.35,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 216.06,
    y1: 239.73,
    x2: 289.18,
    y2: 239.73,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 268.26,
    y1: 480.35,
    x2: 320.72,
    y2: 480.35,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 334.62,
    y1: 515.76,
    x2: 361.28,
    y2: 515.76,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 136.52,
    y1: 414.95,
    x2: 409.87,
    y2: 362.67,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 195.69,
    y1: 444.39,
    x2: 458.69,
    y2: 369.79,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 283.68,
    y1: 303.27,
    x2: 353.49,
    y2: 303.27,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 255.41,
    y1: 141.69,
    x2: 307.01,
    y2: 141.69,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 218.97,
    y1: 432.55,
    x2: 390.74,
    y2: 165.95,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 242.27,
    y1: 447.56,
    x2: 414.05,
    y2: 180.96,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 152.57,
    y1: 30.16,
    x2: 61.41,
    y2: 181.36,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 445.97,
    y1: 270.9,
    x2: 77.59,
    y2: 122.25,
    xlinkHref: "#linear-gradient-5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M269.92,479.47c-27.03,15.61-27.17,40.93-.31,56.54,26.85,15.6,70.56,15.6,97.59-.01,27.03-15.6,27.18-40.92.32-56.52-26.86-15.61-70.57-15.61-97.6,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M557.51,192.38l-.43,151.17c0,.84-.04,1.65-.11,2.44-.01.07-.02.14-.03.21-.07.71-.17,1.4-.3,2.07-.02.09-.04.17-.05.26-.14.64-.3,1.26-.48,1.85-.04.11-.07.22-.11.32-.19.56-.39,1.08-.62,1.59-.03.05-.05.12-.08.17-.27.57-.57,1.11-.89,1.62-.04.06-.09.12-.14.19-.27.4-.56.78-.86,1.14-.11.13-.23.25-.35.37-.26.29-.54.56-.83.81-.12.1-.24.21-.36.31-.35.28-.71.53-1.08.75l-7.59,4.4c.45-.26.87-.57,1.28-.9.13-.1.25-.2.37-.31.29-.25.57-.52.83-.8.12-.13.23-.25.34-.38.31-.35.6-.73.87-1.14.04-.06.09-.12.14-.19.32-.5.62-1.04.89-1.61.03-.06.05-.12.08-.18.23-.5.43-1.03.62-1.58.03-.11.07-.22.11-.33.18-.59.34-1.2.48-1.84.01-.09.03-.18.05-.27.13-.66.23-1.35.3-2.07.01-.07.02-.14.02-.21.08-.78.12-1.59.12-2.43l.43-151.18c0-.84-.03-1.7-.1-2.56-.01-.07-.01-.14-.02-.22-.07-.86-.18-1.73-.32-2.61v-.04c-.14-.87-.32-1.74-.52-2.61-.02-.09-.03-.17-.05-.25-.2-.85-.43-1.7-.69-2.54-.01-.06-.03-.11-.04-.16-.27-.89-.57-1.77-.89-2.65-.02-.05-.05-.11-.07-.17-.32-.85-.66-1.71-1.03-2.55-.02-.05-.04-.1-.06-.14-.38-.87-.79-1.72-1.22-2.57-.04-.08-.08-.16-.12-.23-.35-.7-.73-1.38-1.12-2.06-.11-.2-.21-.4-.33-.59-.23-.41-.49-.8-.74-1.2-.29-.48-.59-.96-.9-1.43-.49-.75-1.01-1.49-1.54-2.21,0-.01-.01-.01-.01-.02-.59-.79-1.19-1.56-1.82-2.31-.01-.01-.01-.02-.02-.03-.61-.73-1.24-1.44-1.89-2.12-.05-.06-.1-.11-.15-.16-.6-.64-1.22-1.25-1.85-1.84-.07-.07-.15-.14-.22-.21-.62-.57-1.25-1.12-1.9-1.65-.07-.06-.15-.12-.22-.18-.66-.53-1.34-1.04-2.02-1.51-.05-.04-.09-.07-.14-.1-.73-.5-1.47-.98-2.23-1.41L296.8,26.04c-.75-.42-1.48-.8-2.21-1.14-.05-.02-.1-.04-.14-.06-.72-.33-1.43-.61-2.12-.85-.05-.01-.09-.03-.14-.04-.66-.23-1.32-.41-1.96-.55-.07-.01-.13-.03-.19-.04-.63-.14-1.25-.23-1.85-.29-.07,0-.14-.01-.21-.02-.58-.04-1.14-.05-1.69-.03-.12,0-.24.01-.35.02-.57.03-1.13.1-1.67.21-.09.01-.18.05-.27.07-.47.11-.92.23-1.36.39-.44.16-.88.35-1.3.56l12.02-6.96s0-.01.01-.01c.1-.06.2-.12.31-.17l-5.37,3.11c.54-.31,1.12-.57,1.71-.78.44-.16.89-.29,1.36-.39.09-.03.18-.06.27-.08.54-.11,1.1-.17,1.67-.21.11,0,.23-.01.35-.01.55-.02,1.11-.02,1.69.03.07,0,.14.01.21.02.6.06,1.22.15,1.85.28.06.02.12.03.19.05.64.14,1.3.32,1.96.54.05.02.09.03.14.05.69.23,1.4.52,2.12.84.04.02.09.05.14.07.73.33,1.46.71,2.21,1.14l231.1,132.25c.76.44,1.5.91,2.24,1.42.04.03.08.06.13.09.68.48,1.36.98,2.02,1.52.08.06.15.12.23.18.64.52,1.27,1.07,1.89,1.65.07.07.15.13.22.2.63.59,1.25,1.21,1.85,1.84.05.06.1.11.16.16.64.69,1.27,1.4,1.88,2.13.01.01.01.02.02.03.63.74,1.23,1.52,1.82,2.31,0,0,.01.01.01.02.53.72,1.05,1.46,1.54,2.21.32.47.61.95.9,1.43.25.39.51.79.74,1.19.12.2.22.4.33.59.39.68.77,1.37,1.12,2.06.04.08.09.16.12.23.43.85.84,1.71,1.22,2.57.02.05.04.09.06.14.37.85.71,1.7,1.03,2.56.03.05.05.11.07.17.32.88.62,1.76.89,2.64.01.05.03.11.04.16.26.85.49,1.7.69,2.55.02.08.04.16.05.24.2.88.38,1.75.52,2.62,0,.01,0,.03.01.04.14.88.24,1.75.31,2.61.01.07.01.14.02.21.07.87.1,1.72.1,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M527.91,158.3c12.32,7.08,22.27,24.24,22.23,38.33l-.43,151.17c-.04,14.09-10.06,19.77-22.37,12.69l-231.11-132.25c-12.32-7.08-22.27-24.24-22.23-38.33l.43-151.17c.04-14.09,10.06-19.77,22.37-12.69l231.11,132.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M273.99,190.28c-.04,14.05,9.88,31.16,22.16,38.21l21.11,12.08,37.71,21.58,20.92,11.98,6.08,3.48,52.45,30.01,7.19,4.12,2.2,1.26,22.42,12.83,52.45,30.01,4.7,2.69,2.2,1.26,1.25.72c12.29,7.05,22.28,1.39,22.3-12.65l.44-150.7c.04-14.04-9.88-31.16-22.16-38.21L296.72,26.93c-12.28-7.06-22.26-1.39-22.29,12.66l-.29,98.39-.15,52.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M295.07,48.22c1.78,1.03,3.22,3.52,3.21,5.56,0,2.05-1.45,2.87-3.23,1.85-1.78-1.03-3.22-3.52-3.21-5.57,0-2.04,1.45-2.87,3.24-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M304.11,53.44c1.78,1.03,3.22,3.52,3.21,5.56,0,2.05-1.45,2.87-3.24,1.84s-3.22-3.52-3.21-5.57c0-2.04,1.45-2.87,3.23-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.16,58.67c1.78,1.03,3.22,3.52,3.21,5.56,0,2.05-1.45,2.87-3.23,1.85-1.78-1.03-3.22-3.52-3.21-5.57,0-2.04,1.46-2.86,3.24-1.84Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.3,221.65c6.66,3.84,12.04,13.16,12.01,20.81l-.23,149.85c-.02,7.65-5.44,10.73-12.09,6.89l-71.41-41.23c-6.66-3.84-12.04-13.16-12.01-20.81l.23-149.85c.02-7.65,5.44-10.73,12.09-6.89l71.41,41.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M502.64,248.21c0-.19-.01-.39-.03-.58,0-.09-.01-.18-.02-.27,0-.04,0-.08,0-.11,0-.07,0-.14-.02-.21-.02-.2-.04-.39-.07-.59-.03-.2-.05-.4-.09-.61,0,0,0-.01,0-.02,0,0,0-.02,0-.02-.03-.19-.06-.38-.1-.57-.04-.21-.08-.42-.13-.63-.02-.07-.04-.15-.05-.22,0-.04-.02-.09-.03-.13-.02-.09-.04-.19-.06-.28-.05-.21-.11-.43-.17-.64-.04-.16-.09-.31-.14-.47,0-.03-.02-.06-.02-.08,0-.03-.02-.06-.02-.09-.06-.21-.13-.42-.2-.63-.07-.21-.14-.41-.21-.62-.01-.04-.03-.08-.04-.12-.01-.03-.02-.06-.03-.09-.05-.13-.1-.26-.15-.39-.08-.2-.16-.39-.24-.59-.06-.14-.12-.28-.18-.42-.01-.02-.02-.05-.03-.07-.01-.03-.02-.06-.04-.08-.09-.2-.17-.39-.27-.58-.1-.21-.2-.43-.31-.64-.02-.03-.03-.06-.05-.1-.02-.04-.04-.08-.06-.12-.09-.17-.17-.34-.26-.51-.11-.21-.23-.41-.35-.62-.06-.11-.12-.21-.18-.32-.02-.04-.05-.08-.07-.12-.11-.18-.22-.35-.33-.53-.16-.26-.32-.52-.49-.77-.03-.04-.05-.08-.08-.12-.25-.37-.5-.73-.76-1.09,0,0,0,0,0,0,0,0,0,0,0,0-.18-.24-.36-.47-.54-.71-.15-.19-.3-.37-.45-.56,0,0,0,0-.01-.01,0,0,0,0,0,0-.15-.18-.31-.37-.47-.55-.15-.18-.31-.35-.47-.52-.03-.03-.05-.05-.08-.08-.03-.03-.06-.06-.08-.09-.11-.12-.22-.24-.33-.35-.17-.17-.34-.34-.51-.5-.05-.05-.11-.1-.16-.15-.04-.04-.08-.07-.12-.11-.08-.08-.17-.16-.25-.23-.18-.16-.36-.32-.54-.47-.08-.07-.16-.13-.24-.19-.04-.03-.08-.07-.12-.1-.06-.05-.12-.1-.18-.15-.18-.14-.35-.27-.53-.4-.13-.09-.26-.18-.39-.27-.02-.02-.05-.04-.07-.05-.02-.02-.04-.03-.07-.05-.17-.12-.34-.23-.51-.34-.17-.11-.34-.21-.51-.31-.04-.02-.08-.05-.12-.07l-71.64-41.36c-.13-.07-.26-.15-.38-.22-.17-.09-.33-.18-.5-.26-.11-.05-.21-.1-.32-.15-.03-.01-.05-.02-.08-.04-.03-.01-.06-.03-.09-.04-.16-.07-.32-.14-.48-.21-.16-.07-.33-.13-.49-.18-.03,0-.06-.02-.08-.03-.02,0-.05-.02-.07-.02-.11-.04-.22-.07-.33-.11-.17-.05-.33-.1-.5-.14-.08-.02-.16-.04-.24-.05-.03,0-.07-.02-.1-.02-.05-.01-.1-.02-.15-.03-.18-.03-.35-.06-.53-.09-.11-.01-.21-.02-.32-.03-.04,0-.07,0-.11-.01-.04,0-.07,0-.11-.01-.19-.01-.38-.02-.57-.02-.08,0-.16,0-.24.01-.06,0-.13,0-.19,0-.06,0-.13,0-.19,0-.24.02-.47.06-.7.1,0,0,0,0-.01,0-.05.01-.09.03-.14.04-.23.05-.47.11-.69.19-.02,0-.03.02-.05.02-.32.12-.63.26-.92.43,0,0,0,0,0,0l-6.74,3.92c.29-.17.6-.31.93-.43.24-.09.48-.15.74-.21.05-.01.1-.03.15-.04.29-.06.6-.09.9-.11.06,0,.13,0,.19,0,.3-.01.61,0,.92.02.04,0,.07,0,.11.01.33.03.66.08,1,.15.03,0,.07.02.1.02.35.08.7.18,1.07.3.02,0,.05.02.07.02.38.13.76.28,1.15.46.03.01.05.02.08.04.39.18.79.39,1.2.62l71.64,41.36c.41.24.81.49,1.21.77.02.02.05.03.07.05.37.26.74.53,1.1.82.04.03.08.07.12.1.35.29.69.59,1.03.9.04.04.08.07.12.11.34.32.67.65,1,1,.03.03.06.06.08.09.35.37.69.76,1.02,1.16,0,0,0,.01.01.02.34.41.67.83.99,1.26t0,0s0,0,0,0c.29.39.57.8.84,1.2.17.26.33.52.49.78.13.22.27.43.4.65.06.11.12.21.18.32.21.37.41.74.61,1.12.02.04.04.08.07.13.23.46.45.93.66,1.4.01.03.02.05.03.08.2.46.39.93.56,1.39.01.03.02.06.03.09.18.48.34.96.48,1.44,0,.03.02.06.03.09.14.46.26.92.37,1.39.01.04.02.09.03.13.11.48.2.95.28,1.42,0,0,0,.02,0,.02.08.48.13.95.17,1.42,0,.04,0,.08,0,.12.04.47.06.94.06,1.4l-.23,150.11c0,.46-.02.9-.06,1.33,0,.04,0,.08-.01.11-.04.39-.09.77-.16,1.13,0,.05-.02.1-.03.14-.07.35-.16.68-.26,1-.02.06-.04.12-.06.18-.1.3-.21.59-.34.86-.01.03-.03.06-.04.1-.15.31-.31.61-.49.88-.02.04-.05.07-.07.1-.15.22-.3.43-.47.62-.06.07-.12.14-.19.2-.15.16-.3.3-.45.44-.07.06-.13.12-.2.17-.22.18-.45.34-.7.49l6.74-3.92c.25-.14.48-.31.7-.49.07-.05.13-.11.2-.17.16-.14.31-.28.45-.44.06-.07.13-.13.19-.2.17-.19.32-.4.47-.62.02-.04.05-.07.07-.1,0,0,.01-.02.02-.02.17-.26.32-.54.46-.83,0,0,0-.02.01-.03.01-.03.03-.06.04-.1.08-.18.16-.37.24-.56.04-.1.07-.2.1-.3.02-.06.04-.12.06-.18.02-.05.04-.1.05-.16.06-.2.11-.41.16-.62.02-.07.03-.15.05-.23,0-.05.02-.1.03-.14.01-.07.03-.14.04-.22.03-.19.06-.38.09-.58.01-.11.02-.22.03-.33,0-.04,0-.08.01-.11,0-.05.01-.09.01-.14.02-.19.03-.38.04-.57,0-.19.01-.39.01-.58,0-.01,0-.02,0-.03l.23-150.11c0-.18,0-.36,0-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M483.86,231.8c6.68,3.86,12.07,13.2,12.05,20.88l-.23,150.11c-.02,7.67-5.45,10.77-12.13,6.91l-71.64-41.36c-6.68-3.86-12.07-13.2-12.05-20.88l.23-150.11c.02-7.67,5.45-10.77,12.13-6.91l71.64,41.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M483.6,232.15c6.66,3.84,12.04,13.16,12.01,20.81l-.23,149.85c-.02,7.65-5.44,10.73-12.09,6.89l-71.41-41.23c-6.66-3.84-12.04-13.16-12.01-20.81l.23-149.85c.02-7.65,5.44-10.73,12.09-6.89l71.41,41.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M412.9,201.16c1.11.64,2.01,2.19,2,3.47s-.91,1.79-2.02,1.15c-1.11-.64-2.01-2.2-2.01-3.48,0-1.28.91-1.79,2.02-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M418.55,204.42c1.11.64,2.01,2.2,2.01,3.47s-.91,1.79-2.02,1.15c-1.11-.64-2.01-2.19-2-3.47,0-1.28.91-1.79,2.02-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M424.2,207.69c1.11.64,2.01,2.19,2,3.47s-.91,1.79-2.02,1.15c-1.11-.64-2.01-2.2-2.01-3.48,0-1.28.91-1.79,2.02-1.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 427.58,
    y1: 260.74,
    x2: 436.56,
    y2: 265.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 412.89,
    y1: 238.12,
    x2: 420.63,
    y2: 242.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 412.89,
    y1: 252.87,
    x2: 420.63,
    y2: 257.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 412.89,
    y1: 293.78,
    x2: 420.63,
    y2: 298.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 412.89,
    y1: 307.53,
    x2: 420.63,
    y2: 312
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 412.89,
    y1: 267.01,
    x2: 462.63,
    y2: 295.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 412.89,
    y1: 223.76,
    x2: 447.04,
    y2: 243.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 466.32,
    y1: 254.61,
    x2: 453.21,
    y2: 247.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 442.13,
    y1: 298.25,
    x2: 412.89,
    y2: 281.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 462.63,
    y1: 267.46,
    x2: 427.58,
    y2: 247.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 412.89,
    y1: 348.61,
    x2: 436.56,
    y2: 362.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 412.89,
    y1: 320.11,
    x2: 447.04,
    y2: 339.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 466.32,
    y1: 350.96,
    x2: 453.21,
    y2: 343.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 462.63,
    y1: 363.81,
    x2: 412.89,
    y2: 335.09
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M277.46,257.48c11.51,12.57,19.43,28.57,24.83,48.87,3.92,14.76,7.61,29.7,8.82,44.97,1.45,18.36,2.54,36.99-.96,55.07-3.15,16.3-9.98,31.74-18.66,45.9-15.92,25.98-38.65,48.23-66.35,60.91-44.5,20.35-87.35,8.25-129.02-11.25-13.47-6.3-27.14-12.74-38.26-22.61-24.36-21.63-32.72-57.47-27.02-89.54,4.58-25.79,17.15-49.37,32.63-70.23,14.41-19.42,39.58-28.38,58.18-44.29,31.59-27.02,54.24-62.16,101.93-48.48,23.48,6.74,40.95,16.55,53.89,30.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203.28,241.02c-18.63.5-32.52,7.33-43.86,21.71-10.11,12.82-17.94,27.49-30.26,38.46-16.58,14.76-39.76,21.27-54.42,37.93-8.87,10.08-15.5,24.5-21.19,36.59-5.47,11.61-.06,28.98,9.36,37.4,5.38,4.8,12.71,6.57,19.56,8.84,21.27,7.06,40.27,20.39,62.11,25.41,36.59,8.41,71.14-6.1,92.19-36.07,9.34-13.3,18.76-26.74,24.93-41.78,8.27-20.15,10.34-42.34,10.01-64.13-.22-14.17,0-25.13-10.04-36.36-14.78-16.55-35.6-28.61-58.39-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M193.09,252.4c1.32-3.22,3.36-5.89,4.58-9.15,1.16-3.09,3.01-4.7,5.69-6.67,5.33-3.92,11.2-6.39,17.62-7.89,15.33-3.57,4.17,15.58,6.5,22.31,3.78,10.9,20.25,16.52,26.24,26.62,2.98,5.02,4.21,10.86,5.06,16.63,2.54,17.1,2.13,34.64-1.18,51.6-.81,4.14-1.83,8.34-4.09,11.9-5.27,8.29-15.75,11.17-24.24,16.11-17.18,9.99-22.22,31.39-36.06,44.72-11.48,11.06-34.06,10.83-42.21,24.33-3.35,5.55-2.94,12.5-2.67,18.98.56,13.7-.05,27.45-1.81,41.05-.83,6.41-3.08,14.11-9.39,15.54-8.21,1.86-13.59-8.6-14.17-17-1.07-15.51,3.29-30.8,5.95-46.12,1.64-9.44,2.62-19.29-.11-28.47-2.73-9.18-9.94-17.58-19.39-19.16-3.2-.54-6.68-.23-9.38,1.58-4.26,2.85-5.49,8.47-6.29,13.53-3.77,23.9-5.7,48.1-5.75,72.29-7.39.46-14.46-4.21-18.37-10.5-3.91-6.29-5.08-13.93-5.02-21.34.1-12.67,3.52-25.05,6.91-37.25,2.71-9.75,4-26.45,9.87-34.66,5.25-7.34,17.29-9.02,25.61-10.86,14.9-3.28,30.19-7.04,42.55-16.01,15.42-11.15,24.08-28.73,31.52-45.72,1.66-3.75,4.06-7.5,5.38-11.36,1.3-3.8,1.6-8.28,2.18-12.26,1.29-8.85,2.05-17.78,2.28-26.72.14-5.43.11-11.03,2.17-16.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.57,255.71s-8.52-.13-15.87,16.91c-7.34,17.05-11.67,28.32-14.82,33.04-3.15,4.72-4.46,10.54-3.28,12.55,1.18,2.01,14.56,8.3,20.59,2.4,6.03-5.9,15.6-30.82,16.52-35.67.92-4.85,2.49-30.02-3.15-29.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.39,456.06s-2.23,14.95-2.23,18.75-2.62,23.47,0,27.41c2.62,3.93,4.98,4.59,10.88,4.2,5.9-.39,7.74-14.29,8.26-16,.52-1.7-.13-13.64,2.36-17.05,2.49-3.41,9.7-15.87,8.52-23.6-1.18-7.74-8.39-11.28-8.39-11.28l-19.41,17.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.33,490s-1.53,14.56-3.09,20.07c-1.56,5.51-4.28,15.62-2.04,18.89,2.24,3.27,12.99,3.63,12.99,3.63,0,0,12.56-9.21,13.6-12.36,1.04-3.15,3.89-15.62,3.75-18.63-.14-3.02,2.18-17.71,2.18-17.71l-5.93-11.39-21.46,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M205,372.53s2.45,18.11-14.86,32.45c-17.31,14.34-45.7,27.5-45.7,27.5,0,0-2.8,7.21-2.72,28.65.02,5.07,1.11,18.83.57,20.17-.54,1.34-8.81,22.39-18.95,20.44-10.14-1.95-12.55-6.17-12.83-7.98s-3.49-68.56-3.66-75.9c-.18-7.34,2.53-12.48,8.39-19.32,8.96-10.45,27.18-19.48,28.05-20.15.87-.67,4.49-17.08,7.17-21.76,2.68-4.67,7.61-7.94,17.27-8.11,9.66-.18,40.39,6.83,37.29,24.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M153.74,372.53s-52.07,32.27-56.96,34.02c-4.9,1.75-9.97,3.5-9.97,3.5,0,0-3.85,32.87-3.85,35.14s.18,13.64-.87,15.39c-1.05,1.75-5.94,9.97-19.41,7.34-7.34-2.1-10.32-25.7-12.41-43.01-2.1-17.31-3.15-28.15,1.57-36.02,4.72-7.87,35.43-29.72,49.28-33.39,13.84-3.67,34.19-11.69,43.22-11.19,9.03.5,24.83,5.59,22.55,9.27-2.27,3.67-.94,14.48-13.15,18.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M245.04,273.67s-18.71-12.76-29.9-18.01c-11.19-5.24-27.28-3.5-35.93-3.58-8.65-.09-19.49,1.22-24.04,4.46-4.55,3.23-5.07,21.94-4.46,32.43.61,10.49-.35,17.75-1.22,19.76-.87,2.01-8.92,22.38-11.45,26.49-2.53,4.11-3.15,8.57-3.15,8.57,0,0,44.76,19.58,50.88,24.48,6.12,4.9,20.28,14.86,20.11,16.26-.17,1.4,8.57-34.79,11.36-42.31,2.8-7.52,18.01-33.74,20.46-40.91,2.45-7.17,16.78-12.94,7.34-27.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M88.09,356.13l66.19,37.74c3.32,1.91,7.21,1.33,9.87-.17l34.87-21.34c1.44-2.54,1.85-2.5,2.04-3.5v-.48l-113.46-19.57-.71.42c-.28.17-.52.39-.68.64,0,0,0,0,0,0-.2.54-.34,1.16-.34,1.52v1.8c-.02.87-.08,1.48,2.22,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M85.87,351.47c.1.59.44,1.15,1.03,1.49l38.41,22.17,29.83,17.21c1.84.75,4.54.78,7.46-.77l36.8-21.23c2.23-1.29,2.25-4.51.02-5.82h0l-51.41-29.58-11.21-6.65c-4.26-2.53-9.55-2.56-13.84-.08l-25.05,14.47-10.29,6.12-.71.42c-.28.17-.52.39-.68.64h0c-.33.49-.45,1.07-.34,1.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "95.31 352.35 119.16 338.57 180.36 373.92 156.51 387.69 95.31 352.35"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M128.93,331.14s-.1,7.77,0,8.69c.1.92.26,3.54,1.51,4.79,1.25,1.25,7.57,8.59,7.97,9.9s3.67,4.85,5.05,4.39c1.38-.46,3.15-.25,3.61.04s3.41,1.14,4.39.55c.98-.59,2.82-1.51,3.02-1.64.2-.13.79-4.85,0-8.26-.79-3.41-1.11-4.79-1.11-4.79,0,0-1.9-6.62-2.82-8.2-.92-1.57-2.49-2.56-3.67-2.49-1.18.07-3.94.13-4.99-.2-1.05-.33-2.82-6.43-2.82-6.82s-10.13,4.03-10.13,4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M141.41,329.99s1.44-10.25.56-13.75c-.87-3.5-7.17-8.65-10.49-9.79-3.32-1.14-8.03,3.69-8.42,5-.39,1.32-3.03,6.53-1.99,11.26,1.05,4.72,6.91,16,6.91,16,0,0-.52-5.68,4.2-7.87,4.72-2.19,9.23,2.19,9.23,2.19v-3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M151.45,345.34s4.2,1.77,7.02.66,2.1-3.28,1.64-3.8c-.46-.52-2.36-.92-3.67-.85-1.31.07-1.57,0-1.57,0,0,0-4.33-3.66-4.53-4.12-.2-.46-3.41,5.38-3.41,5.38l4.52,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M197.88,367.44s-3.36-.52-4.32.71c-.99,1.24-4.41,3.73-5.46,4.26-1.05.52-3.02,2.1-3.02,2.1,0,0-4.91,5.12-6.48,5.58s-2.62.65-3.48,0c-.84-.65-1.18-2.22-1.18-2.22,0,0-2.29,2.94-3.55,2.64-1.24-.29-2.1-1.53-2.22-1.93-.13-.4-.46-.92-.46-.92,0,0-2.48,1.91-3.67,1.57-1.18-.31-1.45-2.69-1.24-2.94.19-.27,4.97-7.49,5.83-8.01.8-.48,2.45-2.54,2.66-2.79-.44.29-6.29,4.28-6.99,5.16-.73.92-3.48,4.39-4.72,3.92-1.26-.44-1.85-2.1-1.39-3.27.46-1.18,5.06-6.69,5.06-6.69-.02.02-.04.04-.06.04-.48.27-3.38,1.89-5.14-.04-1.95-2.1,3.17-2.48,3.17-2.48,0,0,.31-.17.86-.48h.02c2.01-1.07,6.97-3.67,8.81-4.24,2.37-.73,11.48-2.16,13.85-2.56,2.35-.4,7.99-2.96,10.81-2.56,2.83.4,9.42,10.47,2.31,15.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M184.85,369.31s-3.15,2.32-4.37,3.85c-1.22,1.53-4.59,3.98-5.03,4.28-.44.31-.83,2.08-.83,2.08,0,0-.91-.9-.67-1.66s4-3.78,4.7-4.31c.7-.52,4.11-3.67,6.21-4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M178.69,366.69s-3.84,4.28-4.78,5.11-5.81,6.57-5.81,6.57l-.38-.71s2.67-3.45,4.15-4.85c1.49-1.4,5.2-5.38,6.82-6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M171.32,365.46l2.58-2.36s-1.77.96-3.09,1.66c-1.31.7-6.33,4.75-6.84,6.29,3.73-2.84,7.34-5.59,7.34-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M171.97,358.41c-.27.21-2.43,1.97-3.99,2.45-1.66.52-4.72,3.73-4.72,3.73-.02.02-.04.04-.06.04-.48.27-3.38,1.89-5.14-.04-1.95-2.1,3.17-2.48,3.17-2.48,0,0,.31-.17.86-.48h.02c1.05.36,9.36-3.04,9.86-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M186.38,256.1s5.64,6.08,6.03,9.27c.39,3.19,13.77,2.4,17.7.87,3.93-1.53,7.08-3.15,7.56-4.94.48-1.79-1.97-4.15-2.97-9.83-1.01-5.68.09-12.55.48-14.21.39-1.66,10.01-25.4-4.15-11.67-14.16,13.73-24.65,30.51-24.65,30.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M252.56,303.96s-3.67,33.83-6.95,44.06c-3.28,10.23-6.69,12.46-6.69,12.46,0,0-13.51-8.26-15.6-14.42s.26-24.78,0-29.24,2.89-23.34,9.7-32.26c6.82-8.92,11.26-10.84,12.51-10.08s6.37,6.54,7.02,15.45c.66,8.92,0,14.03,0,14.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M236.16,346.36s-6.16-5.22-13.31-2.26c-7.15,2.96-21.3,6.15-23.67,6.28-2.36.13-12.06,1.97-12.06,1.97,0,0,10.23-.25,9.7,7.35-.52,7.6-2.75,9.83-2.75,9.83,0,0,13.9,2.23,29.64-2.62,15.74-4.85,15.64-5.8,17.47-9.03,1.83-3.23.1-8.9-5.01-11.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M179.47,209.16s-2.71,3.15-2.71,12.06,1.31,12.41,1.36,14.77c.04,2.36,2.14,18.88,8.44,23.08,6.29,4.2,16.87-2.19,20.19-5.94,3.32-3.76,6.82-10.58,6.91-21.07.09-10.49-2.97-24.04-9.88-25.61-6.91-1.57-24.3,2.71-24.3,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M209.46,235.29s.09-5.33-2.27-6.91c-2.36-1.57-4.63-10.32-4.63-10.32l-3.42-2.88s-6.38,3.15-11.54,3.06c-5.16-.09-10.49-2.21-10.49-2.21l-.29,8.42s-2.25-5.77-2.25-10.06,1.22-12.94,11.8-17.31c10.58-4.37,21.42-.87,23.95,1.66,9.53.96,11.98,15.04,11.71,18.62-.26,3.58-2.68,13.64-3.31,14.34-.62.7.83-6.47-3.22-5.16-4.05,1.31-3.87,7.87-3.87,7.87l-2.19.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M212.78,231.1s.57-3.1,3.37-3.8,3.37,2.54,2.45,5.42c-.92,2.88-2.58,8.04-4.59,7.82-2.01-.22-1.97-4.72-1.97-5.42s.74-4.02.74-4.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "89.36 349.97 116.39 334.36 120.9 336.77 93.71 352.48 89.36 349.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M153.4,393.98l-65.2-39.76c-1.61-.93-.74-2.45-2.02-4.61l-9.44-42.39c-1.61-4.49,1.83-5.97,4.54-5.06l67.67,38.01c1.76.59,4.74,4.17,4.69,6.03l5.16,46.96c-1.32,2.02-2.36,1.53-5.41.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M81.29,302.18l67.67,38.01c.71.24,1.61.96,2.44,1.86l-28.5,20.93c-2.92,1.55-5.62,1.52-7.46.77l-29.83-17.21-1.15-.66-7.71-38.64c-1.61-4.49,1.83-5.97,4.54-5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M76.62,308.1l3.48,20.49,4.3,22.11c1.28,2.17.42,3.68,2.02,4.61l8.27,4.79,24.71,14.33,14.26,8.27,19.47,11.29c1.9.99,2.53,1.46,3.85.66.06-.04.12-.08.19-.12l-5.31-47.24c.05-1.86-2.93-5.43-4.69-6.03l-15.39-8.64-24.31-13.66-14.05-7.89-13.93-7.82c-2.71-.91-4.49.34-2.89,4.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M114.32,343.47c2.36.83,4.65,3.52,5.32,6.35.66,2.77-.65,4.2-3.02,3.37-2.34-.83-4.66-3.54-5.31-6.31s.66-4.24,3.01-3.42Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.3,290.47s-10.15,9.56-11.36,12.32c-1.19,2.75-6.6,14.3-1.88,23.48,2.54,4.96,5.31-.99,7.43-8.97.97-3.61.89-6.51,6.34-9.69,3.95-2.3,8.79-7.47,10.74-10.24,1.96-2.77-11.26-6.89-11.26-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.31,294.94s-4.16,15.14-6.09,19.56c-1.91,4.4-5.1,6.66-5.5,5.56-.43-1.11,4.56-14.46-.51-14.86-2.68-.23,11.01-8.23,12.09-10.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M284.37,176.11s-14.96-5.92-26.01,23.89c-11.05,29.81-12.84,41.81-18.95,51.68-6.12,9.87-23.35,42.25-23.35,42.25,0,0,9.73,1.98,12.39,9.89,0,0,31.72-38.44,39.52-56.3,7.8-17.86,31.22-60.47,16.4-71.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M320.7,474.43c0-.14-.02-.29-.04-.43-.01-.17-.03-.35-.05-.52-.02-.18-.05-.35-.08-.53-.02-.14-.04-.27-.07-.41-.04-.2-.07-.39-.11-.58-.02-.1-.04-.2-.06-.3-.05-.22-.1-.44-.15-.66,0-.02-.01-.05-.02-.07-.54-2.13-1.25-3.8-1.25-3.8,0,0-21.65-6.11-21.94-2.78-.27,3.33-10.83,14.99-15.28,17.88-2.91,1.91-9.31,5.1-12.08,8.48,0,0,0,0,0,0-.09.11-.16.21-.24.32-.04.05-.08.11-.12.16-.1.13-.18.27-.26.4-.03.04-.05.08-.07.12-.25.42-.42.85-.52,1.27-.01.06-.03.11-.04.17-.02.12-.04.24-.04.36,0,.08,0,.15,0,.23,0,.15.01.3.04.46.02.13.05.25.08.38.03.08.06.17.1.25.05.12.1.23.16.35.04.07.08.15.13.22.12.19.25.38.42.56,4.43,5.01,28.02-5.28,30.3-7.76,2.29-2.5,1.32-4.72,8-4.16,6.66.55,7.21-2.22,11.38-4.72.24-.15.45-.32.64-.51.07-.07.12-.15.18-.22.11-.13.22-.27.31-.42.06-.09.11-.19.16-.29.07-.15.14-.29.19-.45.04-.11.08-.22.11-.34.05-.16.08-.33.12-.5.02-.12.05-.23.06-.35.03-.19.04-.39.05-.59,0-.11.02-.22.02-.33,0-.3,0-.6-.01-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M360.94,498.66h-21.18s-.2,3.83-3.31,13.15c-3.08,9.32-1.32,18.64-1.32,18.64,0,0,.66,1.91,4.86,2.39.51.06,1.1-.06,1.74-.3,0,0,0,0,0,0,0,0,0,0,0,0,.2-.07.41-.18.62-.28.12-.05.23-.1.34-.16.24-.13.5-.28.76-.44.08-.05.17-.1.25-.15.29-.18.58-.39.88-.6.05-.03.1-.07.15-.1,4.6-3.34,10.41-10.04,13.53-14.46,4.43-6.21,2.67-17.69,2.67-17.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M309.9,311.9s-19.82-2.15-26.44-16.81c0,0-1.82,32.37,2.2,69.91,4,37.54,7.32,103.56,7.32,103.56,0,0,12.82,12.09,26.07,0,0,0,3.73-43.59,0-67.74,0,0,2.49-42.29-1.65-63.44-4.15-21.14-7.51-25.48-7.51-25.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M356.45,309.64s1.92,21.96,2.33,56.08c.42,34.1,2.9,46.96,3.73,52.18.82,5.24,3.72,62.32,2.07,78.98,0,0-10.77,16.65-27.74,0,0,0-2.89-58.51-5.78-71.84-2.92-13.32-19.12-78.03-25.68-101.25-2.88-10.25-3.56-14.15-3.56-14.15,0,0,28.56,20.54,54.63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M312.11,176.31s32.27,10.91,33.36,13.11c1.1,2.19,9.7,6.62,2.42,34.63,0,0-10.7,30.85.97,58.39,6.79,15.97,11.91,24.06,11.91,24.06,0,0-10.42,21.73-49.9,13.45-7.96-1.67-22.18-10.13-27.23-17.85,0,0-.09-25-8.98-52.93-8.89-27.93-16.98-64.67-1.45-72,0,0,3.4-5.59,38.9-.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M287.22,280.6l28.53-16.55c3.43-1.99,7.83-.78,9.77,2.68l27.08,48.57c1.84,3.3.77,7.47-2.43,9.47l-28.04,17.6c-3.45,2.16-8.01.99-9.98-2.57l-27.57-49.61c-1.88-3.38-.7-7.65,2.64-9.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.91,
    cy: 286.93,
    r: 2.87
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.36,
    cy: 292.91,
    r: 2.87
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M304.23,152.02s-3.56,16.5,6.74,22.72c5.73,3.45,1.3,18.71-14.49,23.75,0,0-7.53.98-7.79-1.79-.62-6.28-4.12-8.6-8.26-12-4.14-3.38,23.81-32.68,23.81-32.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.59,143.41s2.97,18.85-5.93,31.36c-7.89,11.12-18.45,20.49-25.63,8.71-5.71-9.35-20.57-33.07-13.68-41.65,8.89-11.06,9.91-20.87,25.05-21.11,0,0,17.84,1.08,20.21,22.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M303.94,163.03s8.51-17.26-2.81-32.89c0,0-7.9-13.03-24.13-8.87-7.79,1.99-20.37,8.23-20.23,25.41.05,5.36,3.71,14.9,20.22,3.01,2.36-1.71,8.98-5.33,12.32-4.05,3.35,1.28,5.24,5.35,5.42,9.36.18,3.51,3.04,2.77,3.17,1.98.11-.81.18-11.06,4.88-8.88,4.21,1.97,1.27,14.18,1.17,14.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M301.12,130.14s-2.85-4.68-8.61-7.55c-1.27-.75-9.77-5.21-22.91.99-6.71,3.16-11.65,12.42-12.62,14.43-5.05,10.44,2.05,26.23,21.02,11.9,0,0,.87-.64,2.09-1.83,3.23-1.65,6.96-3.3,9.21-2.44,3.35,1.28,5.24,5.35,5.42,9.36.18,3.51,3.04,2.77,3.17,1.98.11-.81.18-11.06,4.88-8.88,4.21,1.97,1.27,14.18,1.17,14.92,0,0,8.51-17.26-2.81-32.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M320.19,304.21s-10.65,5.46-13.62,4.7c-2.96-.75-4.94,3.12-1.35,3.69,3.6.56,7.5-.82,7.5-.82,0,0-10.77,8.89-14.17,6.35-3.41-2.55,5.28,9.6,11.98,8.13,6.69-1.43,14.29-1.81,19.29-18.35,0,0-3.74-4.32-9.63-3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.89,194.81c1.1-8.57,12.5-18.56,22.54-1.62,10.04,16.94,28.75,70.7,21.86,78.5-2.68,3.04-7.49,6.76-11.96,3.75-6.98-4.68-13.94-19.13-16.65-27.32-4.47-13.45-16.82-45.29-15.79-53.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M371.46,268.54s-7.99,28.01-44.29,46.73c0,0-.82-6.27-8.6-9.93,0,0,42.21-76.56,52.89-36.8Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 423.26,
    y1: 159.3,
    x2: 345.01,
    y2: 114.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 377.83,
    y1: 146.3,
    x2: 345.01,
    y2: 127.52
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M329.77,101.14l-.08,18.59-.03,7.71c0,2.42-1.73,3.4-3.84,2.19l-23.09-13.33c-2.11-1.22-3.81-4.17-3.81-6.59h0s.11-26.3.11-26.3c0-2.43,1.72-3.4,3.84-2.19l23.09,13.33c2.11,1.22,3.82,4.17,3.81,6.6Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M66.86,121.68c0-.18.01-.37.03-.56,0-.08.01-.17.02-.26,0-.04,0-.07,0-.11,0-.07,0-.13.02-.2.02-.19.04-.38.06-.56.02-.19.05-.38.08-.58,0,0,0-.01,0-.02,0,0,0-.02,0-.02.03-.18.06-.36.09-.54.04-.2.08-.4.12-.6.02-.07.03-.14.05-.21,0-.04.02-.08.03-.12.02-.09.04-.18.06-.26.05-.2.1-.41.16-.61.04-.15.09-.3.13-.45,0-.03.02-.05.02-.08,0-.03.02-.05.02-.08.06-.2.12-.4.19-.59.07-.2.13-.39.2-.59.01-.04.03-.07.04-.11.01-.03.02-.06.03-.09.05-.12.09-.25.14-.37.07-.19.15-.37.22-.56.06-.13.11-.27.17-.4,0-.02.02-.05.03-.07.01-.03.02-.05.03-.08.08-.19.17-.37.25-.56.1-.2.19-.41.29-.61.02-.03.03-.06.05-.09.02-.04.04-.08.06-.12.08-.16.16-.32.25-.48.11-.2.22-.39.33-.59.06-.1.11-.2.17-.3.02-.04.04-.08.07-.12.1-.17.21-.34.32-.5.15-.25.3-.5.46-.74.03-.04.05-.08.07-.12.23-.35.48-.7.73-1.04,0,0,0,0,0,0,0,0,0,0,0,0,.17-.23.34-.45.51-.67.14-.18.28-.35.43-.53,0,0,0,0,0-.01,0,0,0,0,0,0,.15-.18.29-.35.44-.52.15-.17.3-.33.45-.5.02-.03.05-.05.07-.08.03-.03.05-.05.08-.08.11-.11.21-.22.32-.33.16-.16.32-.32.49-.48.05-.05.1-.09.15-.14.04-.04.08-.07.11-.11.08-.07.16-.15.24-.22.17-.15.34-.3.51-.45.07-.06.15-.12.23-.18.04-.03.08-.06.12-.1.06-.05.11-.09.17-.14.17-.13.34-.26.5-.39.12-.09.24-.18.37-.26.02-.02.05-.03.07-.05.02-.01.04-.03.06-.04.16-.11.32-.22.49-.32.16-.1.32-.2.49-.3.04-.02.08-.04.11-.07l68.17-39.36c.12-.07.24-.14.37-.2.16-.09.31-.17.47-.24.1-.05.2-.1.3-.14.02-.01.05-.02.07-.03.03-.01.06-.03.09-.04.15-.07.31-.13.46-.2.16-.06.31-.12.46-.17.03,0,.05-.02.08-.03.02,0,.05-.02.07-.02.1-.04.21-.07.31-.1.16-.05.32-.09.48-.13.08-.02.15-.03.23-.05.03,0,.07-.01.1-.02.05-.01.1-.02.15-.03.17-.03.34-.06.5-.08.1-.01.2-.02.3-.03.04,0,.07,0,.11-.01.03,0,.07,0,.1-.01.18-.01.36-.02.54-.02.08,0,.15,0,.23.01.06,0,.12,0,.18,0,.06,0,.12,0,.19,0,.23.02.45.05.66.1,0,0,0,0,.01,0,.05,0,.09.03.14.04.22.05.44.11.66.18.02,0,.03.02.05.02.31.11.6.24.88.41,0,0,0,0,0,0l6.41,3.73c-.28-.16-.58-.3-.88-.41-.23-.08-.46-.15-.7-.2-.05-.01-.09-.03-.14-.04-.28-.06-.57-.09-.86-.11-.06,0-.12,0-.18,0-.29-.01-.58,0-.87.02-.04,0-.07,0-.11.01-.31.03-.63.08-.95.15-.03,0-.07.01-.1.02-.33.07-.67.17-1.01.28-.02,0-.05.01-.07.02-.36.12-.72.27-1.09.44-.02.01-.05.02-.07.03-.38.17-.76.37-1.14.59l-68.17,39.36c-.39.22-.77.47-1.15.73-.02.02-.05.03-.07.05-.35.25-.7.51-1.04.78-.04.03-.08.06-.12.1-.33.27-.66.56-.98.85-.04.04-.08.07-.11.11-.32.31-.64.62-.95.95-.03.03-.05.06-.08.08-.33.35-.66.72-.97,1.1,0,0,0,.01-.01.02-.32.39-.63.79-.94,1.2t0,0s0,0,0,0c-.27.37-.54.76-.8,1.15-.16.24-.31.49-.46.74-.13.21-.26.41-.38.62-.06.1-.11.2-.17.31-.2.35-.39.71-.58,1.07-.02.04-.04.08-.06.12-.22.44-.43.88-.63,1.33-.01.02-.02.05-.03.07-.19.44-.37.88-.53,1.33-.01.03-.02.06-.03.09-.17.45-.32.91-.46,1.37,0,.03-.02.06-.02.08-.13.44-.25.88-.35,1.32,0,.04-.02.09-.03.13-.1.45-.19.91-.26,1.35,0,0,0,.01,0,.02-.07.45-.13.9-.16,1.35,0,.04,0,.07,0,.11-.03.45-.05.89-.05,1.33l.22,78.33c0,.44.02.86.06,1.26,0,.04,0,.07.01.11.04.37.09.73.16,1.07,0,.05.02.09.03.14.07.33.15.65.25.96.02.06.04.11.06.17.1.29.2.56.32.82.01.03.02.06.04.09.14.3.29.58.46.84.02.03.05.06.07.1.14.21.29.41.45.59.06.07.12.13.18.19.14.15.28.29.43.42.06.05.12.11.19.16.21.17.43.33.67.46l-6.41-3.73c-.23-.14-.45-.29-.67-.46-.06-.05-.12-.11-.19-.16-.15-.13-.29-.27-.43-.42-.06-.06-.12-.13-.18-.19-.16-.19-.31-.38-.45-.59-.02-.03-.05-.06-.07-.1,0,0-.01-.01-.02-.02-.16-.25-.3-.51-.43-.79,0,0,0-.02-.01-.03-.01-.03-.02-.06-.04-.09-.08-.17-.16-.35-.23-.54-.03-.09-.06-.19-.09-.28-.02-.06-.04-.11-.06-.17-.02-.05-.03-.1-.05-.15-.06-.19-.11-.39-.15-.59-.02-.07-.03-.14-.04-.22,0-.05-.02-.09-.03-.14-.01-.07-.03-.14-.04-.21-.03-.18-.06-.36-.08-.55-.01-.1-.02-.21-.03-.31,0-.04,0-.07-.01-.11,0-.04,0-.09-.01-.13-.01-.18-.03-.36-.03-.54,0-.18-.01-.37-.01-.56,0-.01,0-.02,0-.03l-.22-78.33c0-.17,0-.35,0-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M84.74,106.07c-6.35,3.67-11.49,12.56-11.47,19.86l.22,78.33c.02,7.3,5.19,10.25,11.54,6.58l68.17-39.36c6.35-3.67,11.49-12.56,11.47-19.86l-.22-78.33c-.02-7.3-5.19-10.25-11.54-6.58l-68.17,39.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M164.67,151.81c.02,7.28-5.1,16.15-11.43,19.8l-67.96,39.23c-6.33,3.66-11.49.72-11.51-6.55l-.22-78.09c-.02-7.28,5.1-16.15,11.44-19.8l67.95-39.23c6.33-3.66,11.49-.72,11.51,6.55l.05,17.85.09,31.29.08,28.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "110.34 134.95 110.35 138.83 96.28 154.5 96.28 154.59 110.39 154.03 110.4 157.86 92.61 158.21 92.61 155.11 110.34 134.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "125.27 119.73 116.22 156.23 113 158.09 122.06 121.59 125.27 119.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "127.55 125.01 145.34 124.58 145.35 127.85 127.61 147.93 127.6 144.1 141.89 128.25 141.89 128.17 127.56 128.85 127.55 125.01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIllustration);
export default __webpack_public_path__ + "static/media/service_illustration.d78248e2c7e7395cfdbc26cae55b6d97.svg";
export { ForwardRef as ReactComponent };